// extracted by mini-css-extract-plugin
export default {"FacetOption":"FacetOption-module__FacetOption--yHSNb","TrailingAction":"FacetOption-module__TrailingAction--z4RaH","TruncateWrap":"FacetOption-module__TruncateWrap--Lmsrm"};